import defaultAttributes from '../defaultAttributes';
import type { IconNode } from '../types';

const Repeat1: IconNode = [
  'svg',
  defaultAttributes,
  [
    ['path', { d: 'm17 2 4 4-4 4' }],
    ['path', { d: 'M3 11v-1a4 4 0 0 1 4-4h14' }],
    ['path', { d: 'm7 22-4-4 4-4' }],
    ['path', { d: 'M21 13v1a4 4 0 0 1-4 4H3' }],
    ['path', { d: 'M11 10h1v4' }],
  ],
];

export default Repeat1;
